import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { UnblockService } from 'src/app/_services/unblock.service';
import { Location } from '@angular/common';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-unblock-request-modal',
  templateUrl: './unblock-request-modal.component.html',
  styleUrls: ['./unblock-request-modal.component.scss']
})
export class UnblockRequestModalComponent implements OnChanges {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @Input() requestsVisible: boolean = false;
  @Input() isInitiator!: boolean;
  @Input() customerData: any;
  @Input() permissions: any;

 // @ViewChild('modalUnblockRequest') private modalUnblockRequestComponent: ModalComponent;
  @Output() requestSubmitted: EventEmitter<void> = new EventEmitter<void>();
  @Output() requestApproved: EventEmitter<void> = new EventEmitter<void>();
  @Output() closeModal: EventEmitter<void> = new EventEmitter();
  @Output() requestRejected: EventEmitter<void> = new EventEmitter<void>();

  selectedFile: File | null = null;
  fileErrorMessage: string = '';
  readonly MAX_FILE_SIZE = 10* 1024 * 1024; 

  

customer: any = {
  fullName: '',
  contactNumber: '',
  screeningProvider: '',
  blockedBy: '',
  blockedOn: '',
  screeningOn: '',
  reasonRemarks: '',
  statusAfterUnblock: 'ACTIVE',
  userId: '',
  initiatorRemarks: '',       
  initiatorDocument: '',
  initiatorID:'',      
  remark: '',
  status:'',
  approverRemarks:'',
  currentRemark:''
};


  constructor(private unblockService: UnblockService) {}
  ngOnInit(){
    console.log("ngOnInit")
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("fjjjjj")
    console.log(this.customerData);
  if (changes['customerData'] && changes['customerData'].currentValue) {
    this.setCustomerData(changes['customerData'].currentValue);
  }
}


setCustomerData(data: any) {
  this.customer.fullName = data.fullName || '';
  this.customer.contactNumber = data.mobileNumber || data.contactNumber || '';
  this.customer.screeningProvider = data.screeningProviderCode || '';
  this.customer.blockedBy = data.blockedBy || '';
  this.customer.blockedOn = data.blockedOn || '';
  this.customer.screeningOn = data.screeningOn || '';
  this.customer.reasonRemarks = data.remark || '';
  this.customer.userId = data.userId || '';
  this.customer.remark = data.remark || '';
  this.customer.initiatorRemarks = data.initiatorRemarks || '';
  this.customer.initiatorDocument = data.initiatorDocument || '';
  this.customer.initiatorID=data.initiatorID  || '';
  this.customer.userType=data.userType  || '';
  this.customer.status=data.status;
  this.customer.approverRemarks=data.approverRemarks;
  
}
onFileSelected(event: any) {
  const file: File = event.target.files[0];
  if (!file) return;

  if (file.size > this.MAX_FILE_SIZE) {
    this.fileErrorMessage = `File size should not exceed ${this.MAX_FILE_SIZE / (1024 * 1024)} MB`;
    this.selectedFile = null; 
    return;
  }

if (
  file.type === 'application/pdf' || 
  file.type === 'text/csv' || 
  file.type === 'image/jpeg' || 
  file.type === 'image/png' || 
  file.type === 'image/gif'
) {    this.selectedFile = file;
    this.fileErrorMessage = '';
  } else {
    this.fileErrorMessage = 'Only PDF or CSV files are allowed';
    this.selectedFile = null;
  }
}


  submitRequest() {
// Frontend validation

  if (!this.customer.initaitorRemarks) {
    this.fileErrorMessage = 'Reason is mandatory';
    return;
  }

  if (!this.customer.initaitorRemarks || this.customer.initaitorRemarks.length <21 || this.customer.initaitorRemarks.length >101) {
    this.fileErrorMessage = 'Remark must be between 20 and 100 characters';
    return;
  }


  const requestData = {
    remark: this.customer.initaitorRemarks,
    userId: this.customer.userId || this.customerData?.userId,
    action: 'INITIATE',// Change action here,
    initiatorID:this.customer.initiatorID,
    fullName:this.customer.fullName

  };

  this.unblockService.submitUnblockRequest(this.selectedFile, requestData)
    .subscribe({
      next: (res: any) => {

        console.log(res)
             if (res?.response?.status !== 200) {
        this.fileErrorMessage = res?.response?.message || 'Something went wrong';
        return; // stop further execution
      }
        console.log('Unblock request submitted successfully', res);
        this.fileErrorMessage = ''; // clear previous errors
        this.requestSubmitted.emit();
        this.selectedFile = null;
        this.fileInput.nativeElement.value = '';
        this.customer.initaitorRemarks = '';

          this.requestSubmitted.emit();

      this.resetModal();
       this.closeModal.emit(); 
        
      },
      error: (err: any) => {
        console.error('Error submitting unblock request', err);
        // Backend wraps message inside response.message
        this.fileErrorMessage = err?.error?.response?.message || 'Something went wrong';
      }
    });
  }

onCancel() {
   this.resetModal();

  this.customer.initaitorRemarks = '';
  this.selectedFile = null;
     this.fileErrorMessage =''
  if (this.fileInput) this.fileInput.nativeElement.value = '';
  this.requestSubmitted.emit();
  this.resetModal();
  this.closeModal.emit();  
  setTimeout(() => {
    this.fileErrorMessage = '';
  }, 2000);
}

// Called when modal closes (cancel, submit, approve, reject)
resetModal() {
  this.selectedFile = null;
  this.fileErrorMessage = '';
}


approveRequest() {
  if (!this.customer.approverRemarks || this.customer.approverRemarks.length <21 || this.customer.approverRemarks.length >101) {
    this.fileErrorMessage = 'Remark must be between 20 and 100 characters';
    return;
  }

  const requestData = {
    remark: this.customer.approverRemarks,
    userId: this.customer.userId || this.customerData?.userId,
    action: 'APPROVE',
    initiatorID:this.customer.initiatorID,
    fullName:this.customer.fullName
  };

  
  this.unblockService.submitUnblockRequest(this.selectedFile, requestData)
    .subscribe({
      next: (res: any) => {

             if (res?.response?.status !== 200) {
        this.fileErrorMessage = res?.response?.message || 'Something went wrong';
        return; // stop further execution
      }
        this.requestApproved.emit(); // 
        this.resetFields();
      },
      error: (err: any) => {
        this.fileErrorMessage =
          err?.error?.response?.message || err?.error?.message || err?.message || 'Something went wrong';
      }
    });
}



private resetFields() {
  this.customer.initaitorRemarks = '';
  this.selectedFile = null;
  this.fileErrorMessage = '';
  if (this.fileInput) this.fileInput.nativeElement.value = '';
}


downloadInitiatorDocs() {
  if (!this.customer.userId) return;

  this.unblockService.downloadInitiatorDocs(this.customer.userId).subscribe({
    next: (blob: Blob) => {
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob);
      a.href = url;
      a.download = 'initiator-docs.zip'; // name for downloaded file
      a.click();
      URL.revokeObjectURL(url);
    },
    error: (err) => {
      console.error('Error downloading document', err);
    }
  });
}


rejectRequest() {
  //here intiatorremarks we are reffering to approverremark
  if (!this.customer.approverRemarks || this.customer.approverRemarks.length < 5) {
    this.fileErrorMessage = 'Reason required';
    return;
  }

  const requestData = {
    remark: this.customer.initaitorRemarks,
    userId: this.customer.userId || this.customerData?.userId,
    action: 'REJECT', // Change action here,
    initiatorID:this.customer.initiatorID,
    fullName:this.customer.fullName
  };

  this.unblockService.submitUnblockRequest(this.selectedFile, requestData)
    .subscribe({
      next: (res: any) => {
        if (res?.response?.status !== 200) {
          this.fileErrorMessage = res?.response?.message || 'Something went wrong';
          return; // stop further execution
        }
        this.requestRejected.emit(); // separate event for rejection
        this.resetFields(); // reset fields like file, remarks, error message
      },
      error: (err: any) => {
        this.fileErrorMessage =
          err?.error?.response?.message || err?.error?.message || err?.message || 'Something went wrong';
      }
    });
}

}
